const BACKEND_DATE_STANDARD = 'YYYY-MM-DD';

export default BACKEND_DATE_STANDARD;
